import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { BREAKING } from "@/data/news";
import api from "@/lib/api";

/**
 * Live breaking-news ticker. Pulls latest published articles from
 * /api/public/breaking every 60 seconds. Falls back to static BREAKING
 * only if the network call fails on first load.
 */
export default function TopMarquee() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => {
      api.get("/public/breaking?limit=12")
        .then((r) => { if (alive && r.data && r.data.length) setItems(r.data); })
        .catch(() => { /* keep whatever we had */ });
    };
    load();
    const t = setInterval(load, 60_000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  const list = (items && items.length ? items : BREAKING.map((b) => ({ title: b, slug: "", kicker: "" })));

  return (
    <div
      data-testid="breaking-marquee"
      className="dp-marquee bg-[#D92525] text-white font-sans-dev border-y border-[#0F0F0F]"
    >
      <div className="max-w-[1400px] mx-auto flex items-stretch">
        <div className="shrink-0 bg-[#0A0A0A] text-white px-4 md:px-5 py-2.5 flex items-center gap-2 uppercase tracking-[0.24em] text-[11px] font-bold">
          <span className="w-2 h-2 rounded-full bg-[#D92525] animate-pulse" />
          ब्रेकिंग
        </div>
        <div className="flex-1 overflow-hidden">
          <Marquee speed={45} gradient={false} pauseOnHover>
            {list.map((b, i) => {
              const label = b.kicker ? `${b.kicker} · ${b.title}` : b.title;
              return b.slug ? (
                <a
                  key={i}
                  href={`/news/${b.slug}`}
                  data-testid={`breaking-${i}`}
                  className="tick-dot text-[13px] md:text-[14px] font-medium py-2.5 text-white hover:opacity-80 no-underline"
                >
                  {label}
                </a>
              ) : (
                <span key={i} data-testid={`breaking-${i}`} className="tick-dot text-[13px] md:text-[14px] font-medium py-2.5">
                  {label}
                </span>
              );
            })}
          </Marquee>
        </div>
      </div>
    </div>
  );
}
